import { createFileRoute, Link } from "@tanstack/react-router";
import { ShieldAlert, Phone, Wind } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/crisis")({
  head: () => ({ meta: [{ title: "Crisis support — Serenity" }] }),
  component: CrisisPage,
});

const lines = [
  { region: "United States", name: "988 Suicide & Crisis Lifeline", phone: "988", href: "tel:988" },
  { region: "India", name: "iCall (TISS)", phone: "+91 9152987821", href: "tel:+919152987821" },
  { region: "India", name: "Vandrevala Foundation", phone: "1860 2662 345", href: "tel:18602662345" },
  { region: "UK & Ireland", name: "Samaritans", phone: "116 123", href: "tel:116123" },
  { region: "Canada", name: "Talk Suicide Canada", phone: "1-833-456-4566", href: "tel:18334564566" },
  { region: "Australia", name: "Lifeline Australia", phone: "13 11 14", href: "tel:131114" },
  { region: "International", name: "Befrienders Worldwide", phone: "Find a helpline", href: "https://befrienders.org" },
];

export default function CrisisPage() {
  return (
    <div className="min-h-screen px-6 py-12">
      <div className="max-w-2xl mx-auto space-y-8">
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back to Serenity</Link>

        <div className="glass rounded-3xl p-8 space-y-4 border-destructive/40">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-2xl bg-destructive/20 flex items-center justify-center">
              <ShieldAlert className="h-6 w-6 text-destructive" />
            </div>
            <h1 className="text-3xl text-gradient">You matter. Help is here.</h1>
          </div>
          <p className="text-muted-foreground">If you are in immediate danger, please call your local emergency number now. The lines below are free, confidential, and answer 24/7.</p>
        </div>

        <div className="space-y-2">
          <h2 className="text-xl mb-3">Crisis lines</h2>
          {lines.map((l) => (
            <a key={l.name} href={l.href} className="glass rounded-2xl p-4 flex items-center justify-between hover:border-primary/40 transition">
              <div>
                <div className="text-xs text-muted-foreground">{l.region}</div>
                <div className="font-medium">{l.name}</div>
              </div>
              <div className="flex items-center gap-2 text-accent"><Phone className="h-4 w-4" />{l.phone}</div>
            </a>
          ))}
        </div>

        <div className="glass rounded-3xl p-6 space-y-4">
          <div className="flex items-center gap-3">
            <Wind className="h-5 w-5 text-accent" />
            <h2 className="text-xl">Grounding: 5-4-3-2-1</h2>
          </div>
          <p className="text-sm text-muted-foreground">When everything feels too much, slow down and notice:</p>
          <ul className="space-y-2 text-sm">
            <li><span className="text-accent font-medium">5</span> things you can see</li>
            <li><span className="text-accent font-medium">4</span> things you can touch</li>
            <li><span className="text-accent font-medium">3</span> things you can hear</li>
            <li><span className="text-accent font-medium">2</span> things you can smell</li>
            <li><span className="text-accent font-medium">1</span> thing you can taste</li>
          </ul>
          <p className="text-sm text-muted-foreground">Breathe in for 4. Hold for 4. Out for 6. Repeat 4 times.</p>
        </div>

        <Link to="/dashboard"><Button variant="secondary" className="w-full">Return to Serenity</Button></Link>
      </div>
    </div>
  );
}
